import _ from 'lodash';
import useGlobalContext from '~/view-data/use-global-context';

const initialState = {
  filter: {
    use: false,
    visible: false,
    data: {},
  },
};

const useHeader = () => {
  const { state: { header = initialState }, dispatch } = useGlobalContext();

  const configure = (options) => {
    const {
      filter = { use: !!options.useFilter, visible: false, data: {} },
      onSearch = null,
      count = 'none',
      ...rest
    } = options;

    dispatch({ type: 'header', merge: true, payload: { ...rest, onSearch, count, filter } });
  };

  const showFilter = () => {
    dispatch({ type: 'header', merge: true, payload: { filter: { visible: true } } });
  };

  const hideFilter = () => {
    dispatch({ type: 'header', merge: true, payload: { filter: { visible: false } } });
  };

  const clearFilter = (data) => {
    dispatch({ type: 'header', payload: { filter: { data, visible: true } } });
  };

  const callFilter = (data = {}, actionFilter = _.noop) => {
    dispatch({ type: 'header', payload: { filter: { data, visible: true } }});
    actionFilter(data);
  };

  return {
    state: {
      ...header,
    },
    actions: {
      configure,
      showFilter,
      hideFilter,
      callFilter,
      clearFilter,
    }
  };
};

export default useHeader;
